// Referral code capture + storage helpers.
// We persist the code in a 90-day cookie + localStorage so that a friend who
// visits via ?ref=abcd1234, then signs up days later, is still attributed.

const COOKIE = "sn_ref";
const LS_KEY = "sn_ref";
const MAX_AGE_DAYS = 90;

const isValid = (code: string) => /^[a-z0-9]{6,12}$/.test(code);

export function captureFromUrl() {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("ref");
    if (!raw) return;
    const code = raw.toLowerCase().trim();
    if (!isValid(code)) return;
    setReferralCode(code);
  } catch {
    /* noop */
  }
}

export function setReferralCode(code: string) {
  try {
    localStorage.setItem(LS_KEY, code);
    const expires = new Date(Date.now() + MAX_AGE_DAYS * 86400_000).toUTCString();
    document.cookie = `${COOKIE}=${code}; expires=${expires}; path=/; SameSite=Lax`;
  } catch {}
}

export function getReferralCode(): string | null {
  try {
    const fromLs = localStorage.getItem(LS_KEY);
    if (fromLs && isValid(fromLs)) return fromLs;
    const m = document.cookie.match(/(?:^|; )sn_ref=([^;]+)/);
    if (m && isValid(m[1])) return m[1];
  } catch {}
  return null;
}

export function clearReferralCode() {
  try {
    localStorage.removeItem(LS_KEY);
    document.cookie = `${COOKIE}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  } catch {}
}

export function buildShareUrl(code: string): string {
  const origin =
    typeof window !== "undefined" ? window.location.origin : "https://shikshannivesh.com";
  return `${origin}/ai-investing-club?ref=${code}`;
}
